import React from "react";
import styled from "styled-components";
import 인스타이미지 from "../assets/images/insta.png";

const LinkInsta = () => {
  return (
    <Container
      onClick={() => {
        window.open("https://www.instagram.com/digimon_face/");
      }}
    >
      <Icon src={인스타이미지} />
      <Text>유명인 결과보기</Text>
    </Container>
  );
};

export default LinkInsta;

const Container = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #ffffff;

  margin: auto auto 30px auto;
  height: 30px;
  width: 160px;
  border-radius: 10px;

  gap: 4px;
`;

const Icon = styled.img`
  width: 18px;
  height: 18px;
`;

const Text = styled.div`
  font-size: 20px;

  color: #000000;
`;
